//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'EducationRow',
	props: {
		index: {
			type: Number,
			required: true
		},
		row: {
			type: Object,
			required: true
		},
		is_new: {
			type: Boolean,
			required: true
		},
		set_value: {
			type: Function,
			required: true
		},
	},
	computed: {
		calc_class_names() {
			return {
				'row': true,
				'form-section': true,
				'visible-section': true,
				'full-bleed': this.index % 2 !== 0,
			};
		},
		section_head() {
			const { row } = this;

			if (row.school_univ) {
				return `${row.school_univ}`;
			} else {
				return "New Row";
			}
		},
	},
	methods: {
		handle_delete_row() {
			this.$emit("delete-row", this.index);
		},
	},
}
